module.exports = __webpack_public_path__ + "static/img/10_2.a10ed39a.jpg";